import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import backIcon from '../../assets/icons/icn-arrow-back.svg'

import styles from './CloseBtn.module.scss'

interface IProps {
  cancel: () => void
}

export const CloseBtn = ({ cancel }: IProps) => (
  <div className={styles.CenterButton}>
    <button onClick={cancel} className={styles.Container}>
      <img src={backIcon} alt={'close'}/>
      <span><FormattedMessage id={'cancel'}/></span>
    </button>
  </div>
)
